// クラウド変数を一時的に保持する

import Vue from 'vue'
import API from '../../api'
import { callApiWithRefresh, timewait } from '../../api/util'

// TODO: LRUでcache化する
const state = {
    accessToken: {},
    refreshToken: {}
}

const getters = {
    getToken(vId) {
        return state.accessToken[vId]
    }
}

const mutations = {
    add(state, { variable, tokenJson }) {
        state[variable.VariableID] = {
            name: variable.Name,
            accessToken: tokenJson.access_token
        }
    },
    refreshToken(state, { vId, token }) {
        Vue.set(state.accessToken, vId, token.access_token)
        Vue.set(state.refreshToken, vId, token.refresh_token)
    }
}

const actions = {
    registerVariable(ctx, { gId, name }) {
        return callApiWithRefresh(
            () => ctx.rootState.groups.accessToken[gId],
            () => ctx.dispatch('groups/_refreshToken', gId, { root: true }),
            (token) => API.registerVariable(name, gId, token)
        )
        .then((v) => {
            ctx.dispatch('groups/getGroup', {gId: ctx.rootState.groups.selected, opts: {refresh: true}}, { root: true }) // cache を更新するためにgetGroupを叩くのでreturn しなくてよい
            return v
        })
    },
    getVariable(ctx, { vId, mode }) {
        if (mode == "share") {
            return API.getVariable(vId, null)
        } else {
            return callApiWithRefresh(
                () => ctx.state.accessToken[vId],
                () => ctx.dispatch('_refreshToken', vId),
                (token) => API.getVariable(vId, token)
            )
        }
    },
    modifyVariable(ctx, vId) {
        return callApiWithRefresh(
            () => ctx.state.accessToken[vId],
            () => ctx.dispatch('_refreshToken', vId),
            (token) => API.modifyVariable(vId, token)
        )
    },
    deleteVariable(ctx, vId) {
        return callApiWithRefresh(
            () => ctx.rootState.account.accessToken,
            () => ctx.dispatch('account/_refreshToken', null, { root: true }),
            (token) => API.deleteVariable(vId, token),
        )
            .then(() => timewait(2000))
            .then(() => {
                ctx.dispatch('groups/getGroup', {gId: ctx.rootState.groups.selected, opts: {refresh: true}}, { root: true })
            })
    },
    getData(ctx, { vId, limit, since = null, until = null, gstate }) {
        if (gstate == "public") {
            return API.getData(vId, limit, null, since, until)
        } else {
            return callApiWithRefresh(
                () => ctx.state.accessToken[vId],
                () => ctx.dispatch('_refreshToken', vId),
                (token) => API.getData(vId, limit, token, since, until)
            )
        }
    },
    sendData(ctx, { vId: vId, data: data }) {
        return callApiWithRefresh(
            () => ctx.state.accessToken[vId],
            () => ctx.dispatch('_refreshToken', vId),
            (token) => API.sendData(data, token)
        )
    },
    _cache(ctx, id) {
        if (!state[id]) {
            return Promise.all([
                API.getVariable(id),
                API.getVariableToken(id, ctx.rootState.account.refreshToken)
            ])
                .then(([variable, tokenJson]) => {
                    ctx.commit("add", { variable, tokenJson })
                })
        }
        return Promise.resolve()
    },
    _refreshToken(ctx, vId) {
        return API.getVariableToken(vId, ctx.rootState.account.refreshToken)
            .then((token) => {
                ctx.commit('refreshToken', { vId, token })
            })
    },
}

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions,
}
